//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
// import $ from 'jquery'

export default {
    data() {
            return {
                screenHight: null,
                //isShow:false
                isClick: false,
                comData: null,
                isShowAlert: false,
                // 定义自定义指令的绑定值
                ifUpdate: false,
                newArr: []
            }
        },
        mounted() {
            this.screenHight = window.screen.availHeight;
            var self = this;
            axios.get('../static/data/comment.json')
                .then(function(response) {
                    var commentCount = self.$route.params.id * 1
                    self.comData = response.data.RECORDS.splice(commentCount, 10);
                    console.log(self.comData);
                    self.ifUpdate = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        computed: {
            // 点击时出现评论页面
            showComment() {
                if (this.$store.state.showComment == true) {
                    this.screenHight = 0;
                } else {
                    this.screenHight = window.screen.availHeight;
                }
            },
            newComment() {
                return this.$store.state.newComment;
            }
        },
        methods: {
            hideComment() {
                this.$store.state.showComment = false;
                this.$store.state.isShowContainer = true;
                console.log(this.$store.state.isShowContainer);
            },
            buttonClick() {
                this.isClick = true;
            },
            send() {
                var cookie = com.getCookie('tel');
                //
                if (cookie == '') {
                    this.isShowAlert = true;
                } else {
                    //console.log(this.ifUpdate);
                    this.ifUpdate = true;
                    var date = new Date();
                    var now = com.currentTime(date);
                    var self = this;
                    //var newData = [];
                    axios.get('http://localhost:8008/savecomment', {
                            params: {
                                imgurl: '../../static/images/404.png',
                                author: com.getCookie('tel'),
                                editetime: now,
                                content: document.getElementsByTagName('input')[0].value
                            }
                        })
                        .then(function(response) {
                            self.newArr.push(response.data[0]);
                            self.$store.state.newComment = self.newArr;
                            self.$store.state.newCommentCount = self.newArr.length;
                            console.log(self.$store.state.newCommentCount);
                            document.getElementsByTagName('input')[0].value = '';
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },
            hideAlert() {
                this.isShowAlert = false;
            }
        }
}



// WEBPACK FOOTER //
// ./src/components/xcomment.vue